import { List, Paper } from "@mui/material";
import React from "react";
import { SystemValueInterface } from "../../Api/System";
import CategoryTitle from "../atoms/CategoryTitle";
import ImagePickerFormListItem from "../molecules/ImagePickerFormListItem";

interface LogoImageSettingsProps {
    systemValue?: SystemValueInterface
    onSave?: (key: string, value: string) => void
}

const LogoImageSettings: React.FC<LogoImageSettingsProps> = ({
    systemValue,
    onSave
}) => {

    return (
        <Paper sx={{margin: "10px"}}>
            <CategoryTitle
                text="ロゴ表示設定"
            />
            <List>
                <ImagePickerFormListItem
                    text="ロゴ"
                    helperText="＊高さ40px程度の、画像ファイルがアップロード可能です。"
                    initialValue={systemValue?.SYSTEM_LOGO_IMGDATA ? `data:${systemValue.SYSTEM_LOGO_MIME_TYPE};base64,${systemValue.SYSTEM_LOGO_IMGDATA}` : ""}
                    imagePickerSx={{
                        width: 200,
                        height: 60,
                    }}
                    imageSx={{
                        objectFit: "scale-down"
                    }}
                    onSave={(value) => {
                        if (onSave) {
                            onSave("SYSTEM_LOGO_IMGDATA", value)
                        }
                    }}
                />
            </List>
        </Paper>
    );
}

export default LogoImageSettings